import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import { LogControllerDtoPowerChargeLogListRequest, PerplayLogApi, } from '../../models/src';
import {
  powerChargeLogList,
  setPowerChargeLogPagination,
  setTotalCount
} from '../../actions/log/powerChargeLogActions';
import { POWERCHARGELOG_LIST_REQUEST } from '../../constants/log/powerChargeLogConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import LogControllerDtoPowerChargeLogListResponse
  from '../../models/src/model/LogControllerDtoPowerChargeLogListResponse';

const api = new PerplayLogApi(config.API_CLIENT);

function* powerChargeLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoPowerChargeLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.searchString = payload.searchString;
    console.log('requestData: ', requestData);
    const result = yield api.apiPerplayLogPowerChargeLogListPost({ logControllerDtoPowerChargeLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoPowerChargeLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    yield put(powerChargeLogList(data.list));
    yield put(setTotalCount(data.totalCount));
    yield put(setPowerChargeLogPagination(
      payload.page,
      data.totalCount,
      payload.beginDate,
      payload.endDate,
      payload.searchCode,
      payload.searchString,
    ));
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* powerChargeLogRootSaga() {
  yield all([
    takeEvery(POWERCHARGELOG_LIST_REQUEST, powerChargeLogListRequestSaga),
  ])
}

const powerChargeLogSagas = [
  fork(powerChargeLogRootSaga),
];

export default powerChargeLogSagas;
